module.exports = __webpack_public_path__ + "static/img/78053B_1_C_20210503_LC.51b3440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78053B_1_C_20210503_LC.png
// module id = fAKb
// module chunks = 0